export const Industries = [
  "Accounting",
  "Airlines/Aviation",
  "Alternative Dispute Resolution",
  "Alternative Medicine",
  "Animation",
  "Apparel & Fashion",
  "Architecture & Planning",
  "Arts & Crafts",
  "Automotive",
  "Aviation & Aerospace",
  "Banking",
  "Biotechnology",
  "Broadcast Media",
  "Building Materials",
  "Business Supplies & Equipment",
  "Capital Markets",
  "Chemicals",
  "Civic & Social Organization",
  "Civil Engineering",
  "Commercial Real Estate",
  "Computer & Network Security",
  "Computer Games",
  "Computer Hardware",
  "Computer Networking",
  "Computer Software",
  "Construction",
  "Consumer Electronics",
  "Consumer Goods",
  "Consumer Services",
  "Cosmetics",
  "Dairy",
  "Defense & Space",
  "Design",
  "Education Management",
  "E-learning",
  "Electrical & Electronic Manufacturing",
  "Entertainment",
  "Environmental Services",
  "Events Services",
  "Executive Office",
  "Facilities Services",
  "Farming",
  "Financial Services",
  "Fine Art",
  "Fishery",
  "Food & Beverages",
  "Food Production",
  "Fundraising",
  "Furniture",
  "Gambling & Casinos",
  "Glass, Ceramics & Concrete",
  "Government Administration",
  "Government Relations",
  "Graphic Design",
  "Health, Wellness & Fitness",
  "Higher Education",
  "Hospital & Health Care",
  "Hospitality",
  "Human Resources",
  "Import & Export",
  "Individual & Family Services",
  "Industrial Automation",
  "Information Services",
  "Information Technology & Services",
  "Insurance",
  "International Affairs",
  "International Trade & Development",
  "Internet",
  "Investment Banking/Venture",
  "Investment Management",
  "Judiciary",
  "Law Enforcement",
  "Law Practice",
  "Legal Services",
  "Legislative Office",
  "Leisure & Travel",
  "Libraries",
  "Logistics & Supply Chain",
  "Luxury Goods & Jewelry",
  "Machinery",
  "Management Consulting",
  "Maritime",
  "Marketing & Advertising",
  "Market Research",
  "Mechanical or Industrial Engineering",
  "Media Production",
  "Medical Device",
  "Medical Practice",
  "Mental Health Care",
  "Military",
  "Mining & Metals",
  "Motion Pictures & Film",
  "Museums & Institutions",
  "Music",
  "Nanotechnology",
  "Newspapers",
  "Nonprofit Organization Management",
  "Oil & Energy",
  "Online Publishing",
  "Outsourcing/Offshoring",
  "Package/Freight Delivery",
  "Packaging & Containers",
  "Paper & Forest Products",
  "Performing Arts",
  "Pharmaceuticals",
  "Philanthropy",
  "Photography",
  "Plastics",
  "Political Organization",
  "Primary/Secondary",
  "Printing",
  "Professional Training",
  "Program Development",
  "Public Policy",
  "Public Relations",
  "Public Safety",
  "Publishing",
  "Railroad Manufacture",
  "Ranching",
  "Real Estate",
  "Recreational",
  "Facilities & Services",
  "Religious Institutions",
  "Renewables & Environment",
  "Research",
  "Restaurants",
  "Retail",
  "Security & Investigations",
  "Semiconductors",
  "Shipbuilding",
  "Sporting Goods",
  "Sports",
  "Staffing & Recruiting",
  "Supermarkets",
  "Telecommunications",
  "Textiles",
  "Think Tanks",
  "Tobacco",
  "Translation & Localization",
  "Transportation/Trucking/Railroad",
  "Utilities",
  "Venture Capital",
  "Veterinary",
  "Warehousing",
  "Wholesale",
  "Wine & Spirits",
  "Wireless",
  "Writing & Editing",
];

export const Occupations = [
  "Accountant",
  "Actor",
  "Actuary",
  "Adhesive bonding machine tender",
  "Adjudicator",
  "Administrative assistant",
  "Administrative services manager",
  "Adult education teacher",
  "Advertising manager",
  "Advertising sales agent",
  "Aerobics instructor",
  "Aerospace engineer",
  "Aerospace engineering technician",
  "Agent",
  "Agricultural engineer",
  "Agricultural equipment operator",
  "Agricultural grader",
  "Agricultural inspector",
  "Agricultural manager",
  "Agricultural sciences teacher",
  "Agricultural sorter",
  "Agricultural technician",
  "Agricultural worker",
  "Air conditioning installer",
  "Air conditioning mechanic",
  "Air traffic controller",
  "Aircraft cargo handling supervisor",
  "Aircraft mechanic",
  "Aircraft service technician",
  "Airline copilot",
  "Airline pilot",
  "Ambulance dispatcher",
  "Ambulance driver",
  "Amusement machine servicer",
  "Anesthesiologist",
  "Animal breeder",
  "Animal control worker",
  "Animal scientist",
  "Animal trainer",
  "Animator",
  "Answering service operator",
  "Anthropologist",
  "Apparel patternmaker",
  "Apparel worker",
  "Arbitrator",
  "Archeologist",
  "Architect",
  "Architectural drafter",
  "Architectural manager",
  "Archivist",
  "Art director",
  "Art teacher",
  "Artist",
  "Assembler",
  "Astronomer",
  "Athlete",
  "Athletic trainer",
  "ATM machine repairer",
  "Atmospheric scientist",
  "Attendant",
  "Audio and video equipment technician",
  "Audio-visual and multimedia collections specialist",
  "Audiologist",
  "Auditor",
  "Author",
  "Auto damage insurance appraiser",
  "Automotive and watercraft service attendant",
  "Automotive glass installer",
  "Automotive mechanic",
  "Avionics technician",
  "Back-end developer",
  "Baggage porter",
  "Bailiff",
  "Baker",
  "Barback",
  "Barber",
  "Bartender",
  "Basic education teacher",
  "Behavioral disorder counselor",
  "Bellhop",
  "Bench carpenter",
  "Bicycle repairer",
  "Bill and account collector",
  "Billing and posting clerk",
  "Biochemist",
  "Biological technician",
  "Biomedical engineer",
  "Biophysicist",
  "Blaster",
  "Blending machine operator",
  "Blockmason",
  "Boiler operator",
  "Boilermaker",
  "Bookkeeper",
  "Boring machine tool tender",
  "Brazer",
  "Brickmason",
  "Bridge and lock tender",
  "Broadcast news analyst",
  "Broadcast technician",
  "Brokerage clerk",
  "Budget analyst",
  "Building inspector",
  "Bus mechanic",
  "Butcher",
  "Buyer",
  "Cabinetmaker",
  "Cafeteria attendant",
  "Cafeteria cook",
  "Camera operator",
  "Camera repairer",
  "Cardiovascular technician",
  "Cargo agent",
  "Carpenter",
  "Carpet installer",
  "Cartographer",
  "Cashier",
  "Caster",
  "Ceiling tile installer",
  "Cellular equipment installer",
  "Cement mason",
  "Channeling machine operator",
  "Chauffeur",
  "Checker",
  "Chef",
  "Chemical engineer",
  "Chemical plant operator",
  "Chemist",
  "Chemistry teacher",
  "Chief executive",
  "Child social worker",
  "Childcare worker",
  "Chiropractor",
  "Choreographer",
  "Civil drafter",
  "Civil engineer",
  "Civil engineering technician",
  "Claims adjuster",
  "Claims examiner",
  "Claims investigator",
  "Cleaner",
  "Clinical laboratory technician",
  "Clinical laboratory technologist",
  "Clinical psychologist",
  "Coating worker",
  "Coatroom attendant",
  "Coil finisher",
  "Coil taper",
  "Coil winder",
  "Coin machine servicer",
  "Commercial diver",
  "Commercial pilot",
  "Commodities sales agent",
  "Communications equipment operator",
  "Communications teacher",
  "Community association manager",
  "Community service manager",
  "Compensation and benefits manager",
  "Compliance officer",
  "Composer",
  "Computer hardware engineer",
  "Computer network architect",
  "Computer operator",
  "Computer programmer",
  "Computer science teacher",
  "Computer support specialist",
  "Computer systems administrator",
  "Computer systems analyst",
  "Concierge",
  "Conciliator",
  "Concrete finisher",
  "Conservation science teacher",
  "Conservation scientist",
  "Conservation worker",
  "Conservator",
  "Construction inspector",
  "Construction manager",
  "Construction painter",
  "Construction worker",
  "Continuous mining machine operator",
  "Convention planner",
  "Conveyor operator",
  "Cook",
  "Cooling equipment operator",
  "Copy marker",
  "Correctional officer",
  "Correctional treatment specialist",
  "Correspondence clerk",
  "Correspondent",
  "Cosmetologist",
  "Cost estimator",
  "Costume attendant",
  "Counseling psychologist",
  "Counselor",
  "Courier",
  "Court reporter",
  "Craft artist",
  "Crane operator",
  "Credit analyst",
  "Credit checker",
  "Credit counselor",
  "Criminal investigator",
  "Criminal justice teacher",
  "Crossing guard",
  "Curator",
  "Custom sewer",
  "Customer service representative",
  "Cutter",
  "Cutting machine operator",
  "Dancer",
  "Data entry keyer",
  "Database administrator",
  "Decorating worker",
  "Delivery services driver",
  "Demonstrator",
  "Dental assistant",
  "Dental hygienist",
  "Dental laboratory technician",
  "Dentist",
  "Dermatologist",
  "Derrick operator",
  "Designer",
  "Desktop publisher",
  "Detective",
  "Developer",
  "Diagnostic medical sonographer",
  "Die maker",
  "Diesel engine specialist",
  "Dietetic technician",
  "Dietitian",
  "Dinkey operator",
  "Director",
  "Dishwasher",
  "Dispatcher",
  "DJ",
  "Doctor",
  "Door-to-door sales worker",
  "Drafter",
  "Dragline operator",
  "Drama teacher",
  "Dredge operator",
  "Dressing room attendant",
  "Dressmaker",
  "Drier operator",
  "Drilling machine tool operator",
  "Dry-cleaning worker",
  "Drywall installer",
  "Dyeing machine operator",
  "Earth driller",
  "Economics teacher",
  "Economist",
  "Editor",
  "Education administrator",
  "Electric motor repairer",
  "Electrical electronics drafter",
  "Electrical engineer",
  "Electrical equipment assembler",
  "Electrical installer",
  "Electrical power-line installer",
  "Electrician",
  "Electro-mechanical technician",
  "Elementary school teacher",
  "Elevator installer",
  "Elevator repairer",
  "Embalmer",
  "Emergency management director",
  "Emergency medical technician",
  "Engine assembler",
  "Engineer",
  "Engineering manager",
  "Engineering teacher",
  "English language teacher",
  "Engraver",
  "Entertainment attendant",
  "Environmental engineer",
  "Environmental science teacher",
  "Environmental scientist",
  "Epidemiologist",
  "Escort",
  "Etcher",
  "Event planner",
  "Excavating operator",
  "Executive administrative assistant",
  "Executive secretary",
  "Exhibit designer",
  "Expediting clerk",
  "Explosives worker",
  "Extraction worker",
  "Fabric mender",
  "Fabric patternmaker",
  "Fabricator",
  "Faller",
  "Family practitioner",
  "Family social worker",
  "Family therapist",
  "Farm advisor",
  "Farm equipment mechanic",
  "Farm labor contractor",
  "Farmer",
  "Farmworker",
  "Fashion designer",
  "Fast food cook",
  "Fence erector",
  "Fiberglass fabricator",
  "Fiberglass laminator",
  "File clerk",
  "Filling machine operator",
  "Film and video editor",
  "Financial analyst",
  "Financial examiner",
  "Financial manager",
  "Financial services sales agent",
  "Fine artist",
  "Fire alarm system installer",
  "Fire dispatcher",
  "Fire inspector",
  "Fire investigator",
  "Firefighter",
  "Fish and game warden",
  "Fish cutter",
  "Fish trimmer",
  "Fisher",
  "Fitness studies teacher",
  "Fitness trainer",
  "Flight attendant",
  "Floor finisher",
  "Floor layer",
  "Floor sander",
  "Floral designer",
  "Food batchmaker",
  "Food cooking machine operator",
  "Food preparation worker",
  "Food science technician",
  "Food scientist",
  "Food server",
  "Food service manager",
  "Food technologist",
  "Foreign language teacher",
  "Foreign literature teacher",
  "Forensic science technician",
  "Forest fire inspector",
  "Forest fire prevention specialist",
  "Forest worker",
  "Forester",
  "Forestry teacher",
  "Forging machine setter",
  "Foundry coremaker",
  "Freight agent",
  "Freight mover",
  "Front-end developer",
  "Fundraising manager",
  "Funeral attendant",
  "Funeral director",
  "Funeral service manager",
  "Furnace operator",
  "Furnishings worker",
  "Furniture finisher",
  "Gaming booth cashier",
  "Gaming cage worker",
  "Gaming change person",
  "Gaming dealer",
  "Gaming investigator",
  "Gaming manager",
  "Gaming surveillance officer",
  "Garment mender",
  "Garment presser",
  "Gas compressor",
  "Gas plant operator",
  "Gas pumping station operator",
  "General manager",
  "General practitioner",
  "Geographer",
  "Geography teacher",
  "Geological engineer",
  "Geological technician",
  "Geoscientist",
  "Glazier",
  "Government program eligibility interviewer",
  "Graduate teaching assistant",
  "Graphic designer",
  "Groundskeeper",
  "Groundskeeping worker",
  "Gynecologist",
  "Hairdresser",
  "Hairstylist",
  "Hand grinding worker",
  "Hand laborer",
  "Hand packager",
  "Hand packer",
  "Hand polishing worker",
  "Hand sewer",
  "Hazardous materials removal worker",
  "Head cook",
  "Health and safety engineer",
  "Health educator",
  "Health information technician",
  "Health services manager",
  "Health specialties teacher",
  "Healthcare social worker",
  "Hearing officer",
  "Heat treating equipment setter",
  "Heating installer",
  "Heating mechanic",
  "Heavy truck driver",
  "Highway maintenance worker",
  "Historian",
  "History teacher",
  "Hoist and winch operator",
  "Home appliance repairer",
  "Home economics teacher",
  "Home entertainment installer",
  "Home health aide",
  "Home management advisor",
  "Host",
  "Hostess",
  "Hostler",
  "Hotel desk clerk",
  "Housekeeping cleaner",
  "Human resources assistant",
  "Human resources manager",
  "Human service assistant",
  "Hunter",
  "Hydrologist",
  "Illustrator",
  "Industrial designer",
  "Industrial engineer",
  "Industrial engineering technician",
  "Industrial machinery mechanic",
  "Industrial production manager",
  "Industrial truck operator",
  "Industrial-organizational psychologist",
  "Information clerk",
  "Information research scientist",
  "Information security analyst",
  "Information systems manager",
  "Inspector",
  "Instructional coordinator",
  "Instructor",
  "Insulation worker",
  "Insurance claims clerk",
  "Insurance sales agent",
  "Insurance underwriter",
  "Intercity bus driver",
  "Interior designer",
  "Internist",
  "Interpreter",
  "Interviewer",
  "Investigator",
  "Jailer",
  "Janitor",
  "Jeweler",
  "Judge",
  "Judicial law clerk",
  "Kettle operator",
  "Kiln operator",
  "Kindergarten teacher",
  "Laboratory animal caretaker",
  "Landscape architect",
  "Landscaping worker",
  "Lathe setter",
  "Laundry worker",
  "Law enforcement teacher",
  "Law teacher",
  "Lawyer",
  "Layout worker",
  "Leather worker",
  "Legal assistant",
  "Legal secretary",
  "Legislator",
  "Librarian",
  "Library assistant",
  "Library science teacher",
  "Library technician",
  "Licensed practical nurse",
  "Licensed vocational nurse",
  "Life scientist",
  "Lifeguard",
  "Light truck driver",
  "Line installer",
  "Literacy teacher",
  "Literature teacher",
  "Loading machine operator",
  "Loan clerk",
  "Loan interviewer",
  "Loan officer",
  "Lobby attendant",
  "Locker room attendant",
  "Locksmith",
  "Locomotive engineer",
  "Locomotive firer",
  "Lodging manager",
  "Log grader",
  "Logging equipment operator",
  "Logistician",
  "Machine feeder",
  "Machinist",
  "Magistrate judge",
  "Magistrate",
  "Maid",
  "Mail clerk",
  "Mail machine operator",
  "Mail superintendent",
  "Maintenance painter",
  "Maintenance worker",
  "Makeup artist",
  "Management analyst",
  "Manicurist",
  "Manufactured building installer",
  "Mapping technician",
  "Marble setter",
  "Marine engineer",
  "Marine oiler",
  "Market research analyst",
  "Marketing manager",
  "Marketing specialist",
  "Marriage therapist",
  "Massage therapist",
  "Material mover",
  "Materials engineer",
  "Materials scientist",
  "Mathematical science teacher",
  "Mathematical technician",
  "Mathematician",
  "Maxillofacial surgeon",
  "Measurer",
  "Meat cutter",
  "Meat packer",
  "Meat trimmer",
  "Mechanical door repairer",
  "Mechanical drafter",
  "Mechanical engineer",
  "Mechanical engineering technician",
  "Mediator",
  "Medical appliance technician",
  "Medical assistant",
  "Medical equipment preparer",
  "Medical equipment repairer",
  "Medical laboratory technician",
  "Medical laboratory technologist",
  "Medical records technician",
  "Medical scientist",
  "Medical secretary",
  "Medical services manager",
  "Medical transcriptionist",
  "Meeting planner",
  "Mental health counselor",
  "Mental health social worker",
  "Merchandise displayer",
  "Messenger",
  "Metal caster",
  "Metal patternmaker",
  "Metal pickling operator",
  "Metal pourer",
  "Metal worker",
  "Metal-refining furnace operator",
  "Metal-refining furnace tender",
  "Meter reader",
  "Microbiologist",
  "Middle school teacher",
  "Milling machine setter",
  "Millwright",
  "Mine cutting machine operator",
  "Mine shuttle car operator",
  "Mining engineer",
  "Mining safety engineer",
  "Mining safety inspector",
  "Mining service unit operator",
  "Mixing machine setter",
  "Mobile heavy equipment mechanic",
  "Mobile home installer",
  "Model maker",
  "Model",
  "Molder",
  "Mortician",
  "Motel desk clerk",
  "Motion picture projectionist",
  "Motorboat mechanic",
  "Motorboat operator",
  "Motorboat service technician",
  "Motorcycle mechanic",
  "Movers",
  "Multimedia artist",
  "Museum technician",
  "Music director",
  "Music teacher",
  "Musical instrument repairer",
  "Musician",
  "Natural sciences manager",
  "Naval architect",
  "Network systems administrator",
  "New accounts clerk",
  "News vendor",
  "Nonfarm animal caretaker",
  "Nuclear engineer",
  "Nuclear medicine technologist",
  "Nuclear power reactor operator",
  "Nuclear technician",
  "Nursing aide",
  "Nursing instructor",
  "Nursing teacher",
  "Nutritionist",
  "Obstetrician",
  "Occupational health and safety specialist",
  "Occupational health and safety technician",
  "Occupational therapist",
  "Occupational therapy aide",
  "Occupational therapy assistant",
  "Offbearer",
  "Office clerk",
  "Office machine operator",
  "Operating engineer",
  "Operations manager",
  "Operations research analyst",
  "Ophthalmic laboratory technician",
  "Optician",
  "Optometrist",
  "Oral surgeon",
  "Order clerk",
  "Order filler",
  "Orderly",
  "Ordnance handling expert",
  "Orthodontist",
  "Orthotist",
  "Outdoor power equipment mechanic",
  "Oven operator",
  "Packaging machine operator",
  "Painter ",
  "Painting worker",
  "Paper goods machine setter",
  "Paperhanger",
  "Paralegal",
  "Paramedic",
  "Parking enforcement worker",
  "Parking lot attendant",
  "Parts salesperson",
  "Paving equipment operator",
  "Payroll clerk",
  "Pediatrician",
  "Pedicurist",
  "Personal care aide",
  "Personal chef",
  "Personal financial advisor",
  "Personal trainer",
  "Pest control worker",
  "Pesticide applicator",
  "Pesticide handler",
  "Pesticide sprayer",
  "Petroleum engineer",
  "Petroleum gauger",
  "Petroleum pump system operator",
  "Petroleum refinery operator",
  "Petroleum technician",
  "Pharmacist",
  "Pharmacy aide",
  "Pharmacy technician",
  "Philosophy teacher",
  "Photogrammetrist",
  "Photographer",
  "Photographic process worker",
  "Photographic processing machine operator",
  "Physical therapist aide",
  "Physical therapist assistant",
  "Physical therapist",
  "Physician assistant",
  "Physician",
  "Physicist",
  "Physics teacher",
  "Pile-driver operator",
  "Pipefitter",
  "Pipelayer",
  "Planing machine operator",
  "Planning clerk",
  "Plant operator",
  "Plant scientist",
  "Plasterer",
  "Plastic patternmaker",
  "Plastic worker",
  "Plumber",
  "Podiatrist",
  "Police dispatcher",
  "Police officer",
  "Policy processing clerk",
  "Political science teacher",
  "Political scientist",
  "Postal service clerk",
  "Postal service mail carrier",
  "Postal service mail processing machine operator",
  "Postal service mail processor",
  "Postal service mail sorter",
  "Postmaster",
  "Postsecondary teacher",
  "Poultry cutter",
  "Poultry trimmer",
  "Power dispatcher",
  "Power distributor",
  "Power plant operator",
  "Power tool repairer",
  "Precious stone worker",
  "Precision instrument repairer",
  "Prepress technician",
  "Preschool teacher",
  "Priest",
  "Print binding worker",
  "Printing press operator",
  "Private detective",
  "Probation officer",
  "Procurement clerk",
  "Producer",
  "Product promoter",
  "Product manager",
  "Production clerk",
  "Production occupation",
  "Proofreader",
  "Property manager",
  "Prosthetist",
  "Prosthodontist",
  "Psychiatric aide",
  "Psychiatric technician",
  "Psychiatrist",
  "Psychologist",
  "Psychology teacher",
  "Public relations manager",
  "Public relations specialist",
  "Pump operator",
  "Purchasing agent",
  "Purchasing manager",
  "Radiation therapist",
  "Radio announcer",
  "Radio equipment installer",
  "Radio operator",
  "Radiologic technician",
  "Radiologic technologist",
  "Rail car repairer",
  "Rail transportation worker",
  "Rail yard engineer",
  "Rail-track laying equipment operator",
  "Railroad brake operator",
  "Railroad conductor",
  "Railroad police",
  "Rancher",
  "Real estate appraiser",
  "Real estate broker",
  "Real estate manager",
  "Real estate sales agent",
  "Receiving clerk",
  "Receptionist",
  "Record clerk",
  "Recreation teacher",
  "Recreation worker",
  "Recreational therapist",
  "Recreational vehicle service technician",
  "Recyclable material collector",
  "Referee",
  "Refractory materials repairer",
  "Refrigeration installer",
  "Refrigeration mechanic",
  "Refuse collector",
  "Regional planner",
  "Registered nurse",
  "Rehabilitation counselor",
  "Reinforcing iron worker",
  "Reinforcing rebar worker",
  "Religion teacher",
  "Religious activities director",
  "Religious worker",
  "Rental clerk",
  "Repair worker",
  "Reporter",
  "Residential advisor",
  "Resort desk clerk",
  "Respiratory therapist",
  "Respiratory therapy technician",
  "Retail buyer",
  "Retail salesperson",
  "Revenue agent",
  "Rigger",
  "Rock splitter",
  "Rolling machine tender",
  "Roof bolter",
  "Roofer",
  "Rotary drill operator",
  "Roustabout",
  "Safe repairer",
  "Sailor",
  "Sales engineer",
  "Sales manager",
  "Sales representative",
  "Sampler",
  "Sawing machine operator",
  "Scaler",
  "School bus driver",
  "School psychologist",
  "School social worker",
  "Scout leader",
  "Sculptor",
  "Secondary education teacher",
  "Secondary school teacher",
  "Secretary",
  "Securities sales agent",
  "Security guard",
  "Security system installer",
  "Segmental paver",
  "Self-enrichment education teacher",
  "Semiconductor processor",
  "Septic tank servicer",
  "Set designer",
  "Sewer pipe cleaner",
  "Sewing machine operator",
  "Shampooer",
  "Shaper",
  "Sheet metal worker",
  "Sheriff's patrol officer",
  "Ship captain",
  "Ship engineer",
  "Ship loader",
  "Shipmate",
  "Shipping clerk",
  "Shoe machine operator",
  "Shoe worker",
  "Short order cook",
  "Signal operator",
  "Signal repairer",
  "Singer",
  "Ski patrol",
  "Skincare specialist",
  "Slaughterer",
  "Slicing machine tender",
  "Slot supervisor",
  "Social science research assistant",
  "Social sciences teacher",
  "Social scientist",
  "Social service assistant",
  "Social service manager",
  "Social work teacher",
  "Social worker",
  "Sociologist",
  "Sociology teacher",
  "Software developer",
  "Software engineer",
  "Soil scientist",
  "Solderer",
  "Sorter",
  "Sound engineering technician",
  "Space scientist",
  "Special education teacher",
  "Speech-language pathologist",
  "Sports book runner",
  "Sports entertainer",
  "Sports performer",
  "Stationary engineer",
  "Statistical assistant",
  "Statistician",
  "Steamfitter",
  "Stock clerk",
  "Stock mover",
  "Stonemason",
  "Street vendor",
  "Streetcar operator",
  "Structural iron worker",
  "Structural metal fabricator",
  "Structural metal fitter",
  "Structural steel worker",
  "Stucco mason",
  "Substance abuse counselor",
  "Substance abuse social worker",
  "Subway operator",
  "Surfacing equipment operator",
  "Surgeon",
  "Surgical technologist",
  "Survey researcher",
  "Surveying technician",
  "Surveyor",
  "Switch operator",
  "Switchboard operator",
  "Tailor",
  "Tamping equipment operator",
  "Tank car loader",
  "Taper",
  "Tax collector",
  "Tax examiner",
  "Tax preparer",
  "Taxi driver",
  "Teacher assistant",
  "Teacher",
  "Team assembler",
  "Technical writer",
  "Telecommunications equipment installer",
  "Telemarketer",
  "Telephone operator",
  "Television announcer",
  "Teller",
  "Terrazzo finisher",
  "Terrazzo worker",
  "Tester",
  "Textile bleaching operator",
  "Textile cutting machine setter",
  "Textile knitting machine setter",
  "Textile presser",
  "Textile worker",
  "Therapist",
  "Ticket agent",
  "Ticket taker",
  "Tile setter",
  "Timekeeping clerk",
  "Timing device assembler",
  "Tire builder",
  "Tire changer",
  "Tire repairer",
  "Title abstractor",
  "Title examiner",
  "Title searcher",
  "Tobacco roasting machine operator",
  "Tool filer",
  "Tool grinder",
  "Tool maker",
  "Tool sharpener",
  "Tour guide",
  "Tower equipment installer",
  "Tower operator",
  "Track switch repairer",
  "Tractor operator",
  "Tractor-trailer truck driver",
  "Traffic clerk",
  "Traffic technician",
  "Training and development manager",
  "Training and development specialist",
  "Transit police",
  "Translator",
  "Transportation equipment painter",
  "Transportation inspector",
  "Transportation security screener",
  "Transportation worker",
  "Trapper",
  "Travel agent",
  "Travel clerk",
  "Travel guide",
  "Tree pruner",
  "Tree trimmer",
  "Trimmer",
  "Truck loader",
  "Truck mechanic",
  "Tuner",
  "Turning machine tool operator",
  "Tutor",
  "Typist",
  "Umpire",
  "Undertaker",
  "Upholsterer",
  "Urban planner",
  "Usher",
  "UX designer",
  "Valve installer",
  "Vending machine servicer",
  "Veterinarian",
  "Veterinary assistant",
  "Veterinary technician",
  "Vocational counselor",
  "Vocational education teacher",
  "Waiter",
  "Waitress",
  "Watch repairer",
  "Water treatment plant operator",
  "Weaving machine setter",
  "Web developer",
  "Weigher",
  "Welder",
  "Wellhead pumper",
  "Wholesale buyer",
  "Wildlife biologist",
  "Window trimmer",
  "Wood patternmaker",
  "Woodworker",
  "Word processor",
  "Writer",
  "Yardmaster",
  "Zoologist",
];
export const amountOptions = [
  { value: 1, label: "$0-10,000" },
  { value: 2, label: "$10,000-$25,000" },
  { value: 3, label: "$25,000-$50,000" },
  { value: 4, label: "$50,000-$100,000" },
  { value: 5, label: "$100,000-$250,000" },
  { value: 6, label: "$250,000-$1,000,000" },
  { value: 7, label: "$1,000,000+" },
];

export const Funds = [
  "Wages",
  "Salary",
  "Commission",
  "Interest",
  "Selling something you create or own",
  "Investments",
  "Gifts",
  "Allowance/Pocket Money",
  "Government Payments",
];

export const countries = [
  { name: "Afghanistan", code: "AF" },
  { name: "land Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: 'Cote D"Ivoire', code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: 'Korea, Democratic People"S Republic of', code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: 'Lao People"S Democratic Republic', code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montenegro", code: "ME" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia", code: "RS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];

export const precision_list_json = [
  {
    CURRENCYID: 1,
    CURRENCY: "USD",
    PRECISION: 2,
  },
  {
    CURRENCYID: 2,
    CURRENCY: "BTC",
    PRECISION: 6,
  },
  {
    CURRENCYID: 3,
    CURRENCY: "ETH",
    PRECISION: 5,
  },
  {
    CURRENCYID: 4,
    CURRENCY: "BCH",
    PRECISION: 5,
  },
  {
    CURRENCYID: 7,
    CURRENCY: "LTC",
    PRECISION: 5,
  },
  {
    CURRENCYID: 8,
    CURRENCY: "HCX",
    PRECISION: 2,
  },
  {
    CURRENCYID: 11,
    CURRENCY: "ETC",
    PRECISION: 5,
  },
  {
    CURRENCYID: 14,
    CURRENCY: "XRP",
    PRECISION: 3,
  },
  {
    CURRENCYID: 16,
    CURRENCY: "USDT",
    PRECISION: 2,
  },
  {
    CURRENCYID: 17,
    CURRENCY: "EOS",
    PRECISION: 8,
  },
  {
    CURRENCYID: 25,
    CURRENCY: "BAT",
    PRECISION: 1,
  },
  {
    CURRENCYID: 26,
    CURRENCY: "HBAR",
    PRECISION: 8,
  },
  {
    CURRENCYID: 27,
    CURRENCY: "LINK",
    PRECISION: 2,
  },
  {
    CURRENCYID: 28,
    CURRENCY: "AED",
    PRECISION: 2,
  },
  {
    CURRENCYID: 35,
    CURRENCY: "INR",
    PRECISION: 2,
  },
  {
    CURRENCYID: 36,
    CURRENCY: "ADA",
    PRECISION: 8,
  },
  {
    CURRENCYID: 124,
    CURRENCY: "DOGE",
    PRECISION: 5,
  },
  {
    CURRENCYID: 144,
    CURRENCY: "XLM",
    PRECISION: 5,
  },
  {
    CURRENCYID: 145,
    CURRENCY: "UNI",
    PRECISION: 5,
  },
  {
    CURRENCYID: 146,
    CURRENCY: "WBTC",
    PRECISION: 5,
  },
  {
    CURRENCYID: 148,
    CURRENCY: "USDC",
    PRECISION: 5,
  },
  {
    CURRENCYID: 150,
    CURRENCY: "SHIB",
    PRECISION: 5,
  },
  {
    CURRENCYID: 151,
    CURRENCY: "BUSD",
    PRECISION: 5,
  },
  {
    CURRENCYID: 152,
    CURRENCY: "DAI",
    PRECISION: 5,
  },
  {
    CURRENCYID: 153,
    CURRENCY: "MKR",
    PRECISION: 5,
  },
  {
    CURRENCYID: 154,
    CURRENCY: "MATIC",
    PRECISION: 5,
  },
  {
    CURRENCYID: 156,
    CURRENCY: "COMP",
    PRECISION: 5,
  },
  {
    CURRENCYID: 157,
    CURRENCY: "GRT",
    PRECISION: 5,
  },
  {
    CURRENCYID: 158,
    CURRENCY: "CHZ",
    PRECISION: 5,
  },
  {
    CURRENCYID: 160,
    CURRENCY: "YFI",
    PRECISION: 5,
  },
  {
    CURRENCYID: 161,
    CURRENCY: "PAX",
    PRECISION: 5,
  },
  {
    CURRENCYID: 162,
    CURRENCY: "SNX",
    PRECISION: 5,
  },
  {
    CURRENCYID: 164,
    CURRENCY: "EUR",
    PRECISION: 5,
  },
  {
    CURRENCYID: 165,
    CURRENCY: "SGD",
    PRECISION: 5,
  },
  {
    CURRENCYID: 167,
    CURRENCY: "AAVE",
    PRECISION: 5,
  },
  {
    CURRENCYID: 185,
    CURRENCY: "SOL",
    PRECISION: 5,
  },
  {
    CURRENCYID: 224,
    CURRENCY: "DOT",
    PRECISION: 5,
  },
  {
    CURRENCYID: 264,
    CURRENCY: "AVAX",
    PRECISION: 5,
  },
  {
    CURRENCYID: 284,
    CURRENCY: "TRX",
    PRECISION: 5,
  },
  {
    CURRENCYID: 613,
    CURRENCY: "NEAR",
    PRECISION: 5,
  },
  {
    CURRENCYID: 631,
    CURRENCY: "VET",
    PRECISION: 5,
  },
  {
    CURRENCYID: 632,
    CURRENCY: "VTHO",
    PRECISION: 5,
  },
  {
    CURRENCYID: 651,
    CURRENCY: "THETA",
    PRECISION: 5,
  },
  {
    CURRENCYID: 652,
    CURRENCY: "TFUEL",
    PRECISION: 5,
  },
  {
    CURRENCYID: 691,
    CURRENCY: "XTZ",
    PRECISION: 8,
  },
  {
    CURRENCYID: 816,
    CURRENCY: "APT",
    PRECISION: 5,
  },
  {
    CURRENCYID: 831,
    CURRENCY: "EGLD",
    PRECISION: 5,
  },
  {
    CURRENCYID: 832,
    CURRENCY: "NEO",
    PRECISION: 5,
  },
  {
    CURRENCYID: 851,
    CURRENCY: "STX",
    PRECISION: 5,
  },
  {
    CURRENCYID: 1022,
    CURRENCY: "CFX",
    PRECISION: 6,
  },
  {
    CURRENCYID: 1036,
    CURRENCY: "GAS",
    PRECISION: 6,
  },
  {
    CURRENCYID: 1111,
    CURRENCY: "FIL",
    PRECISION: 6,
  },
  {
    CURRENCYID: 1151,
    CURRENCY: "BNB",
    PRECISION: 5,
  },
  {
    CURRENCYID: 1199,
    CURRENCY: "ARB",
    PRECISION: 5,
  },
  {
    CURRENCYID: 1351,
    CURRENCY: "SMT",
    PRECISION: 8,
  },
  {
    CURRENCYID: 1451,
    CURRENCY: "LDO",
    PRECISION: 6,
  },
  {
    CURRENCYID: 1631,
    CURRENCY: "TON",
    PRECISION: 6,
  },
  {
    CURRENCYID: 1694,
    CURRENCY: "PEX",
    PRECISION: 8,
  },
  {
    CURRENCYID: 1751,
    CURRENCY: "INJ",
    PRECISION: 5,
  },
  {
    CURRENCYID: 1878,
    CURRENCY: "GBP",
    PRECISION: 2,
  },
  {
    CURRENCYID: 2009,
    CURRENCY: "ARF",
    PRECISION: 6,
  },
  {
    CURRENCYID: 2038,
    CURRENCY: "BPXC",
    PRECISION: 5,
  },
  {
    CURRENCYID: 2240,
    CURRENCY: "HAT",
    PRECISION: 6,
  },
  {
    CURRENCYID: 2438,
    CURRENCY: "PXC",
    PRECISION: 8,
  },
  {
    CURRENCYID: 2960,
    CURRENCY: "DEXE",
    PRECISION: 8,
  },
  {
    CURRENCYID: 3018,
    CURRENCY: "NAD",
    PRECISION: 8,
  },
  {
    CURRENCYID: 3038,
    CURRENCY: "SPUP",
    PRECISION: 8,
  },
  {
    CURRENCYID: 3399,
    CURRENCY: "POL",
    PRECISION: 6,
  },
  {
    CURRENCYID: 3598,
    CURRENCY: "HASHBE",
    PRECISION: 4,
  },
  {
    CURRENCYID: 3599,
    CURRENCY: "HASHHC",
    PRECISION: 5,
  },
  {
    CURRENCYID: 3600,
    CURRENCY: "HASHOT",
    PRECISION: 5,
  },
  {
    CURRENCYID: 3898,
    CURRENCY: "TERC",
    PRECISION: 5,
  },
  {
    CURRENCYID: 4178,
    CURRENCY: "REW",
    PRECISION: 5,
  },
  {
    CURRENCYID: 4198,
    CURRENCY: "SUI",
    PRECISION: 5,
  },
  {
    CURRENCYID: 4758,
    CURRENCY: "CORE",
    PRECISION: 5,
  },
  {
    CURRENCYID: 4838,
    CURRENCY: "AFAS",
    PRECISION: 8,
  },
  {
    CURRENCYID: 4918,
    CURRENCY: "HCP",
    PRECISION: 6,
  },
  {
    CURRENCYID: 4938,
    CURRENCY: "AFD",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5018,
    CURRENCY: "MPY",
    PRECISION: 8,
  },
  {
    CURRENCYID: 5038,
    CURRENCY: "NVV",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5178,
    CURRENCY: "JLC",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5198,
    CURRENCY: "M",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5238,
    CURRENCY: "LANDX",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5258,
    CURRENCY: "SMKY",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5278,
    CURRENCY: "DEEPSEEKAI",
    PRECISION: 8,
  },
  {
    CURRENCYID: 5298,
    CURRENCY: "OTHER",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5299,
    CURRENCY: "RRRR",
    PRECISION: 1,
  },
  {
    CURRENCYID: 5358,
    CURRENCY: "SAD",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5418,
    CURRENCY: "KIP",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5421,
    CURRENCY: "DDC",
    PRECISION: 4,
  },
  {
    CURRENCYID: 5422,
    CURRENCY: "JCB",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5438,
    CURRENCY: "PEB",
    PRECISION: 7,
  },
  {
    CURRENCYID: 5478,
    CURRENCY: "KNG",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5498,
    CURRENCY: "GPT",
    PRECISION: 8,
  },
  {
    CURRENCYID: 5539,
    CURRENCY: "AFF",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5559,
    CURRENCY: "RC",
    PRECISION: 2,
  },
  {
    CURRENCYID: 5561,
    CURRENCY: "ARJ",
    PRECISION: 6,
  },
  {
    CURRENCYID: 5598,
    CURRENCY: "NEQT",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5599,
    CURRENCY: "WEQT",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5618,
    CURRENCY: "GREI",
    PRECISION: 3,
  },
  {
    CURRENCYID: 5639,
    CURRENCY: "BE",
    PRECISION: 2,
  },
  {
    CURRENCYID: 5658,
    CURRENCY: "FRX",
    PRECISION: 5,
  },
  {
    CURRENCYID: 5679,
    CURRENCY: "DRTYCSH",
    PRECISION: 8,
  },
  {
    CURRENCYID: 5698,
    CURRENCY: "TRE",
    PRECISION: 8,
  },
  {
    CURRENCYID: 5720,
    CURRENCY: "WRT",
    PRECISION: 4,
  },
  {
    CURRENCYID: 5721,
    CURRENCY: "CCC",
    PRECISION: 4,
  },
  {
    CURRENCYID: 5738,
    CURRENCY: "SEN",
    PRECISION: 2,
  },
  {
    CURRENCYID: 5758,
    CURRENCY: "DX",
    PRECISION: 2,
  },
  {
    CURRENCYID: 5778,
    CURRENCY: "HUSD",
    PRECISION: 4,
  },
];

export const companyStructures = [
  "Sole Proprietorships",
  "General Partnerships",
  "Limited Liability Company (by members)",
  "Limited Liability Company (sole member)",
  "Free Zone Limited Liability Company",
  "Private Limited Company (by shares)",
  "Public Limited Company",
  "Chartered Company",
  "Statutory Corporation",
  "State Owned Enterprise",
  "Public Sector Undertaking",
  "Holding Company",
  "Subsidiary Company",
  "Unlimited Company",
  "Reciprocal",
  "Cooperative",
  "Non-profit",
  "Trust",
  "Foundation",
  "Others",
];
export const accountPurposes = [
  "Day Trading",
  "Investing",
  "Managing User Assets",
  "Lowering taxes",
  "Cross-border payments",
  "Domestic payments",
  "Others",
];
export const sourceOfFunds = [
  "Income from business",
  "Debt capital",
  "Equity capital",
];

export const ERCCURRENCY = [
  25, 27, 8, 16, 159, 150, 157, 162, 145, 146, 148, 156, 158, 151, 152, 153,
  154, 160, 161, 167, 2240, 2038, 3038, 4918, 2438, 4178, 4838,
];

export const COUNTRYWITHCODE = [
  { name: "Afghanistan", code: "AF", dial_code: "93" },
  { name: "Albania", code: "AL", dial_code: "355" },
  { name: "Algeria", code: "DZ", dial_code: "213" },
  { name: "Andorra", code: "AD", dial_code: "376" },
  { name: "Angola", code: "AO", dial_code: "244" },
  { name: "Argentina", code: "AR", dial_code: "54" },
  { name: "Armenia", code: "AM", dial_code: "374" },
  { name: "Australia", code: "AU", dial_code: "61" },
  { name: "Austria", code: "AT", dial_code: "43" },
  { name: "Azerbaijan", code: "AZ", dial_code: "994" },
  { name: "Bahamas", code: "BS", dial_code: "1-242" },
  { name: "Bahrain", code: "BH", dial_code: "973" },
  { name: "Bangladesh", code: "BD", dial_code: "880" },
  { name: "Belarus", code: "BY", dial_code: "375" },
  { name: "Belgium", code: "BE", dial_code: "32" },
  { name: "Belize", code: "BZ", dial_code: "501" },
  { name: "Benin", code: "BJ", dial_code: "229" },
  { name: "Bhutan", code: "BT", dial_code: "975" },
  { name: "Bolivia", code: "BO", dial_code: "591" },
  { name: "Bosnia and Herzegovina", code: "BA", dial_code: "387" },
  { name: "Botswana", code: "BW", dial_code: "267" },
  { name: "Brazil", code: "BR", dial_code: "55" },
  { name: "Brunei", code: "BN", dial_code: "673" },
  { name: "Bulgaria", code: "BG", dial_code: "359" },
  { name: "Cambodia", code: "KH", dial_code: "855" },
  { name: "Cameroon", code: "CM", dial_code: "237" },
  { name: "Canada", code: "CA", dial_code: "1" },
  { name: "Chile", code: "CL", dial_code: "56" },
  { name: "China", code: "CN", dial_code: "86" },
  { name: "Colombia", code: "CO", dial_code: "57" },
  { name: "Costa Rica", code: "CR", dial_code: "506" },
  { name: "Croatia", code: "HR", dial_code: "385" },
  { name: "Cuba", code: "CU", dial_code: "53" },
  { name: "Cyprus", code: "CY", dial_code: "357" },
  { name: "Czech Republic", code: "CZ", dial_code: "420" },
  { name: "Denmark", code: "DK", dial_code: "45" },
  { name: "Egypt", code: "EG", dial_code: "20" },
  { name: "Estonia", code: "EE", dial_code: "372" },
  { name: "Finland", code: "FI", dial_code: "358" },
  { name: "France", code: "FR", dial_code: "33" },
  { name: "Germany", code: "DE", dial_code: "49" },
  { name: "Ghana", code: "GH", dial_code: "233" },
  { name: "Greece", code: "GR", dial_code: "30" },
  { name: "Hungary", code: "HU", dial_code: "36" },
  { name: "Iceland", code: "IS", dial_code: "354" },
  { name: "India", code: "IN", dial_code: "91" },
  { name: "Indonesia", code: "ID", dial_code: "62" },
  { name: "Iran", code: "IR", dial_code: "98" },
  { name: "Iraq", code: "IQ", dial_code: "964" },
  { name: "Ireland", code: "IE", dial_code: "353" },
  { name: "Israel", code: "IL", dial_code: "972" },
  { name: "Italy", code: "IT", dial_code: "39" },
  { name: "Japan", code: "JP", dial_code: "81" },
  { name: "Jordan", code: "JO", dial_code: "962" },
  { name: "Kazakhstan", code: "KZ", dial_code: "7" },
  { name: "Kenya", code: "KE", dial_code: "254" },
  { name: "Kuwait", code: "KW", dial_code: "965" },
  { name: "Latvia", code: "LV", dial_code: "371" },
  { name: "Lebanon", code: "LB", dial_code: "961" },
  { name: "Lithuania", code: "LT", dial_code: "370" },
  { name: "Luxembourg", code: "LU", dial_code: "352" },
  { name: "Malaysia", code: "MY", dial_code: "60" },
  { name: "Maldives", code: "MV", dial_code: "960" },
  { name: "Mexico", code: "MX", dial_code: "52" },
  { name: "Nepal", code: "NP", dial_code: "977" },
  { name: "Netherlands", code: "NL", dial_code: "31" },
  { name: "New Zealand", code: "NZ", dial_code: "64" },
  { name: "Nigeria", code: "NG", dial_code: "234" },
  { name: "Norway", code: "NO", dial_code: "47" },
  { name: "Oman", code: "OM", dial_code: "968" },
  { name: "Pakistan", code: "PK", dial_code: "92" },
  { name: "Panama", code: "PA", dial_code: "507" },
  { name: "Peru", code: "PE", dial_code: "51" },
  { name: "Philippines", code: "PH", dial_code: "63" },
  { name: "Poland", code: "PL", dial_code: "48" },
  { name: "Portugal", code: "PT", dial_code: "351" },
  { name: "Qatar", code: "QA", dial_code: "974" },
  { name: "Romania", code: "RO", dial_code: "40" },
  { name: "Russia", code: "RU", dial_code: "7" },
  { name: "Saudi Arabia", code: "SA", dial_code: "966" },
  { name: "Singapore", code: "SG", dial_code: "65" },
  { name: "South Africa", code: "ZA", dial_code: "27" },
  { name: "South Korea", code: "KR", dial_code: "82" },
  { name: "Spain", code: "ES", dial_code: "34" },
  { name: "Sri Lanka", code: "LK", dial_code: "94" },
  { name: "Sweden", code: "SE", dial_code: "46" },
  { name: "Switzerland", code: "CH", dial_code: "41" },
  { name: "Thailand", code: "TH", dial_code: "66" },
  { name: "Turkey", code: "TR", dial_code: "90" },
  { name: "Ukraine", code: "UA", dial_code: "380" },
  { name: "United Arab Emirates", code: "AE", dial_code: "971" },
  { name: "United Kingdom", code: "GB", dial_code: "44" },
  { name: "United States", code: "US", dial_code: "1" },
  { name: "Vietnam", code: "VN", dial_code: "84" },
  { name: "Zimbabwe", code: "ZW", dial_code: "263" },
];
